export default __webpack_public_path__ + "static/src/companys/basic/assets/images/logo/logo_light.png";